import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/free-solid-svg-icons'

import { TExtendsHTMLElement } from '../../../types/shared'
import './index.scss'

interface IIconBadgeProps {
  icon: IconDefinition
}

const IconBadge: React.FC<TExtendsHTMLElement<IIconBadgeProps>> = (props) => {
  return (
    <div className='checkmark'>
      <FontAwesomeIcon
        className='fa-xs'
        data-testid='unlimited-checkmark'
        icon={props.icon}
      />
    </div>
  )
}

export {
  IconBadge,
}
